import React from 'react';
import { MapPin } from 'lucide-react';
import './Venue.css';

const Venue = () => {
    return (
        <section id="venue" className="section-container">
            <h2 className="section-title">The Venue</h2>
            <div className="venue-card">
                <div className="venue-image">
                    <img src="/Ceremony.png" alt="David's Country Inn" />
                </div>
                <div className="venue-details">
                    <h3>David's Country Inn</h3>
                    <p className="address">
                        <MapPin size={18} />
                        <span>314 Main St, Hackettstown, NJ 07840</span>
                    </p>
                    <p className="description">
                        We are thrilled to celebrate our special day at David's Country Inn.
                    </p>
                    <div className="dress-code">
                        <h4>Dress Code: Cocktail/Formal Attire</h4>
                        <p>We ask that our guests wear cocktail or formal attire. We kindly ask that you avoid wearing all white or all red.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Venue;
